import React from "react";
import { PhoneIcon } from "@heroicons/react/solid";
import { PdfPhoneClick } from "@/components/community/PhoneReveal";

const NeedHelpBox = () => {
    return (
        <div className="border-2 border-primary-500 rounded-lg p-6 bg-white">
            <div className="text-center">
                <h3 className="text-primary-500 text-lg sm:text-2xl font-bold font-headline mb-2">
                    NEED HELP FINDING ASSISTED LIVING?
                </h3>
                <p className="text-primary-500 text-base sm:text-xl mb-6">
                    Talk to a Live Assisted Living Counselor Today!
                </p>

                <a
                    href="tel:6127877533"
                    className="inline-flex items-center gap-3 bg-primary-500 hover:bg-primary-600 rounded-full px-4 py-3 shadow-lg"
                    onClick={PdfPhoneClick}
                >
                    <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center">
                        <PhoneIcon className="w-5 h-5 text-primary-500" />
                    </div>
                    <span className="text-xl font-bold text-white">612-787-7533</span>
                </a>
            </div>
        </div>
    );
};

export default NeedHelpBox;
